module.exports = __webpack_public_path__ + "static/fonts/FuturaMedium.a8bb1c2.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/FuturaMedium.otf
// module id = 973
// module chunks = 113